var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5V7.5H12C13.704 7.5 15.94 8.538 16.72 10.5H8V12.5H16.97C16.66 15.11 13.974 16.5 12 16.5H8V18.97L18.25 27.5H21.375L10.562 18.5H12C15.234 18.5 18.674 16.11 18.97 12.5H24V10.5H18.812C18.51 9.316 17.86 8.304 17 7.5H24V5.5H8Z",
    fill: "#192BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.afe74adab1a4e9d794918af0e4b4e9ac.svg";
export { ForwardRef as ReactComponent };